<template>
    <div class="hub-payout">
        <b-card no-body>
            <b-card-header class="px-3 py-2">
                <b-row align-v="center">
                    <b-col cols="10">
                        <h3 class="mb-0">
                            Hub Payout
                        </h3>
                    </b-col>
                    <b-col cols="2">
                        <b-link href="#" class="d-flex align-items-center float-right py-0 text-primary">
                            View
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" class="text-primary"><path fill="currentColor" d="M9.4 18 8 16.6l4.6-4.6L8 7.4 9.4 6l6 6-6 6Z"/></svg>
                        </b-link>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-container class="px-3 pt-3">
                <b-row>
                    <b-col cols="12" class="mb-3">
                        <p class="mb-0">Current Payout</p>
                        <div class="d-flex align-items-center justify-content-between">
                            <h3 class="font-weight-bold mb-0">RM {{ batch_payout_total | moneyFormatter }}</h3>
                            <p class="mb-0 text-muted">Paid Quarterly</p>
                        </div>
                    </b-col>
                    <b-col>
                        <b-link href="#" class="mb-0 text-primary" @click="modals.show_table = true">View Details</b-link>
                    </b-col>
                </b-row>
            </b-container>
            <PayoutDetailsTableModal :show_table.sync="modals.show_table" />
        </b-card>
    </div>
</template>
<script>
import { axios, services, getHeader,debounce } from '@/assets/js/httpImports.js'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import PayoutDetailsTableModal from '@/views/Commission/Hub/HubProfile/HubModals/ShowTableModals/PayoutDetailsTableModal'

export default {
    props: ['date_picked'],
    mixins: [clientPaginationMixin],
    components: {
        PayoutDetailsTableModal,
    },
    data() {
        return {
            batch_payout_total: null,
            modals:{
                show_table: false
            },
        }
    },
    watch: {
        date_picked(newValue) {
            if(newValue)
            {
                this.getCurrentPayoutTotal();
            }
        }
    },
    created() {
        this.getCurrentPayoutTotal()
    },
    methods: {
        viewModal() {
            getPoolContributionDetails
        },
        getCurrentPayoutTotal() {
            let queryparams = "";
            if(this.date_picked)
            {
                queryparams = '/' + this.date_picked[0] + '/' + this.date_picked[1];
            }

            axios.get(services.hub + 'hub_comms/direct_payout_batch.show_current_payout_total' + queryparams, { headers: getHeader() })
            .then(res => {
                this.batch_payout_total = res.data.data.batch_payout_total
            })
            .catch ( error => {
                this.errorFunction(error, "Error " + error.response.data.message) 
            });
        },
    }
}
</script>